export default "__VITE_ASSET__Dxuy5MpW__"